(function () {
  'use strict';

  if (window.BvCollectionSubscriptionBanner) {
    window.BvCollectionSubscriptionBanner.initAll();
    return;
  }

  var bannerSelector = '[data-bv-collection-subscription-banner]';
  var subscribedKey = 'bv_subscription_popup_subscribed_v1';
  var subscribedInMemory = false;

  function isSubscribed(banner) {
    if (subscribedInMemory) return true;
    var customerId = banner.getAttribute('data-customer-id') || '';
    var suffix = customerId ? '_customer_' + customerId : '';
    try {
      if (window.localStorage.getItem(subscribedKey) === '1') return true;
    } catch (error) {
      // Storage may be unavailable in private or restricted browsing contexts.
    }
    try {
      return window.sessionStorage.getItem('bv_subscription_popup_v2' + suffix + '_flow_started') === '1';
    } catch (error) {
      return false;
    }
  }

  function initAll() {
    var popup = document.querySelector('.bv-subscription-popup:not([data-bv-subscription-popup-duplicate])');
    Array.prototype.forEach.call(document.querySelectorAll(bannerSelector), function (banner) {
      // Liquid already placed the banner. Never clone, move or remount it after paint.
      banner.hidden = isSubscribed(banner) || !popup || popup.hidden;
    });
  }

  function hideBanners() {
    subscribedInMemory = true;
    Array.prototype.forEach.call(document.querySelectorAll(bannerSelector), function (banner) {
      banner.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('[data-bv-collection-subscription-banner-open]')
      : null;
    var banner = button && button.closest(bannerSelector);
    if (banner && window.BvSubscriptionPopup && typeof window.BvSubscriptionPopup.open === 'function') {
      window.BvSubscriptionPopup.open('collection', banner.getAttribute('data-collection-handle'));
    }
  });

  document.addEventListener('bv:subscription:success', hideBanners);
  window.addEventListener('storage', function (event) {
    if (event.key === subscribedKey && event.newValue === '1') hideBanners();
  });

  window.BvCollectionSubscriptionBanner = { initAll: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
